export default __webpack_public_path__ + "static/media/Бор+Моліб_1л.bcad5086.jpg";